import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  sendEmailVerification as fbSendEmailVerification,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut as fbSignOut,
  type User,
} from "firebase/auth";
import { auth } from "./firebase";

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

export async function signInWithGoogle(): Promise<User> {
  const res = await signInWithPopup(auth, googleProvider);
  return res.user;
}

export async function signInWithEmail(
  email: string,
  password: string
): Promise<User> {
  const res = await signInWithEmailAndPassword(auth, email, password);
  return res.user;
}

export async function signUpWithEmail(
  email: string,
  password: string
): Promise<User> {
  const res = await createUserWithEmailAndPassword(auth, email, password);
  return res.user;
}

export async function signOut(): Promise<void> {
  await fbSignOut(auth);
}

/**
 * Envoie l'email de vérification à l'user courant. Le destinataire reçoit un
 * lien Firebase qui, une fois cliqué, marque `emailVerified: true` côté Auth.
 * Le state n'est rafraîchi que sur le prochain `getIdTokenResult({ forceRefresh })`
 * ou au prochain reload — Firebase ne pousse pas la mutation en temps réel.
 *
 * Retourne `void` sur succès. Throw les codes Firebase standards :
 *   - `auth/too-many-requests` (rate-limited, ~1 req / minute par compte)
 *   - `auth/missing-android-pkg-name` etc. — improbable ici, paramètres
 *     `actionCodeSettings` non fournis donc on utilise les defaults.
 */
export async function sendEmailVerification(user: User): Promise<void> {
  await fbSendEmailVerification(user);
}
